import { createRouter, createWebHistory } from 'vue-router'
import ErrorPage from '@/views/ErrorPage.vue'
import FormPage from '@/views/FormPage.vue'
import ThankYou from '@/views/ThankYou.vue'
import { tokenStore } from '@/stores/tokenStore.js'

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { 
      path: '/:pathMatch', 
      name: 'ErrorPage', 
      component: ErrorPage,
      props: route => ({
        pathMath: route.params.pathMath,
        errorMsg: route.query.errorMsg,
        errorCode: route.query.errorCode,
        errorText: route.query.errorText
      })
    },
    {
      path: '/',
      name: 'FormPage',
      component: FormPage
    },
    {
      path: '/ThankYouPage',
      name: 'ThankYouPage',
      component: ThankYou
    }
  ]
})

router.beforeEach(async (to, from) => {
    if (!await tokenStore().checkAndSaveToken(tokenStore().currentToken) && to.name !== 'ErrorPage') {
      return {
        name: 'ErrorPage',
        query: {
          errorMsg: 'errorOccured',
          errorText: 'unauthorized',
          errorCode: '401'
        },
        params: { pathMatch: 'errorToken' }
      }
    }
    return true
})

